import type { Dispatch, SetStateAction } from 'react'
import IcBaselineChevronLeft from '~icons/ic/baseline-chevron-left'
import IcBaselineChevronRight from '~icons/ic/baseline-chevron-right'

export function SimplePagination(props: {
  page: number
  totalPages: number
  onPageChange: Dispatch<SetStateAction<number>>
}) {
  const { page, totalPages, onPageChange } = props

  return (
    <div className="flex items-center justify-end gap-2 py-4">
      <button
        type="button"
        aria-label="Previous page"
        onClick={() => onPageChange(prev => prev - 1)}
        disabled={page === 0}
        className="p-1 rounded hover:bg-neutral-100 dark:hover:bg-neutral-800 disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <IcBaselineChevronLeft className="size-5" />
      </button>
      <span className="text-sm text-neutral-500">
        {page + 1} / {totalPages}
      </span>
      <button
        type="button"
        aria-label="Next page"
        onClick={() => onPageChange(prev => prev + 1)}
        disabled={page >= totalPages - 1}
        className="p-1 rounded hover:bg-neutral-100 dark:hover:bg-neutral-800 disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <IcBaselineChevronRight className="size-5" />
      </button>
    </div>
  )
}
